export const UserLogoutState = {
	url: '/logout?pe',
	title: 'Logout',
	template: '<logout-page></logout-page>',
	params: {pe: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "userLogoutPageMod" */
			'@Containers/user-logout-page/user-logout-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
